export const AUTH_SESSION_EXPIRED_EVENT = "auth:session-expired";

export const isTelegramMiniApp = () => {
    const telegramWebApp = window.Telegram?.WebApp;

    return Boolean(
        telegramWebApp?.initData ||
        telegramWebApp?.initDataUnsafe?.user?.id ||
        telegramWebApp?.initDataUnsafe?.start_param
    );
};

export const clearStoredAuthSession = (reason = "session-expired") => {
    localStorage.removeItem("token");
    localStorage.removeItem("phone_number");

    window.dispatchEvent(new CustomEvent(AUTH_SESSION_EXPIRED_EVENT, {
        detail: { reason },
    }));
};

export const requestTelegramReauth = (reason = "missing-token") => {
    if (!isTelegramMiniApp()) {
        return false;
    }

    window.dispatchEvent(new CustomEvent(AUTH_SESSION_EXPIRED_EVENT, {
        detail: { reason },
    }));

    return true;
};
